import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'stores/hooks';
import { Button } from 'antd';
import { useUser } from 'stores/user/userHooks';
import { REQUEST_STATUSES } from 'stores/common';
import {
  getUserList,
  getUserListRequestStatus,
  getUserRatesAsync,
  getUserRatesList,
  getUserRatesListRequestStatus,
  getUsersAsync,
} from 'stores/admin/adminSlice';
import { signoutAsync } from 'stores/auth/authSlice';
import AdminTable from 'components/admin/AdminTable';
import Title from 'components/layout/Title';

export default function Admin() {
  const dispatch = useAppDispatch();
  const users = useAppSelector(getUserList);
  const doctorMeetings = useAppSelector(getUserRatesList);
  const doctorMeetingsRequestStatuses = useAppSelector(getUserRatesListRequestStatus);
  const onClickSignOut = useCallback(() => dispatch(signoutAsync()), [dispatch]);
  const loadingUsers = useAppSelector(getUserListRequestStatus);
  const [currentUser] = useUser();

  useEffect(() => {
    dispatch(getUsersAsync());
  }, [dispatch]);

  useEffect(() => {
    users?.forEach((user) => {
      if (user.id) {
        dispatch(getUserRatesAsync({ userWPId: user.id }));
      }
    });
  }, [dispatch, users]);

  return (
    <div>
      <div className='flex flex-wrap items-center space-x-4'>
        <Title main>Administration</Title>
        <Button
          onClick={onClickSignOut}
          className='mb-4'
          type='link'
          danger
        >
          Se déconnecter
        </Button>
      </div>
      <AdminTable
        currentUser={currentUser}
        users={users}
        loading={loadingUsers === REQUEST_STATUSES.PENDING}
        doctorMeetings={doctorMeetings}
        doctorMeetingsRequestStatuses={doctorMeetingsRequestStatuses}
      />
    </div>
  );
}
